import React, { useState, useEffect } from "react";
import { use } from "react";
import RejectDriverModal from "../RejectedModel/RejectedModel";

export default function CustomTable({
  role,
  TableTitle,
  TableData,
  handleActive,
  handleApprove,
  handleView,
  handlerefresh,
  handleEdit,
  handleDelete,
  data,
}) {
  const [loading, setLoading] = useState(false);

  console.log("TABLE DATA ::", TableData);

  const handleAccountStatusChange = (rowData) => {
    handleActive(rowData);
  };

  const handleProfileStatusChange = (rowData) => {
    handleApprove(rowData);
  };

  const EditRow = async (rowData) => {
    console.log("EIDOTOTO ROWW ", rowData);

    // handleEdit(rowData);
  };
  const DeleteRow = (rowData) => {
    console.log("DDELETTEE ROWW ", rowData);
    handleDelete(rowData);
  };

  const ViewRow = (rowData) => {
    console.log("Viewww ROWW ", rowData);
    handleView(rowData);
  };

  const Reject = (data) => {
    handleApprove(data, true);
  };
  const [drivers, setDrivers] = useState([]);
  const [filteredDrivers, setFilteredDrivers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [profileStatusFilter, setProfileStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [img, setImg] = useState(false);
  const rowsPerPage = 10;

  useEffect(() => {
    setDrivers(TableData);
    setFilteredDrivers(TableData);
  }, [TableData]);

  // Search Handler
  useEffect(() => {
    const filtered = drivers?.filter((driver) => {
      const matchesSearch =
        (driver?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()) ??
          false) ||
        (driver?.mobile_number?.includes(searchTerm) ?? false);

      const matchesProfileStatus =
        profileStatusFilter === "" ||
        (profileStatusFilter === "Approved" && driver?.profile_status === 1) ||
        (profileStatusFilter === "Rejected" && driver?.profile_status === 2) ||
        (profileStatusFilter === "Unapproved" &&
          driver?.profile_status !== 1 &&
          driver?.profile_status !== 2);

      return matchesSearch && matchesProfileStatus;
    });

    setFilteredDrivers(filtered);
    setCurrentPage(1);
  }, [searchTerm, profileStatusFilter, drivers]);

  // Pagination Logic
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentDrivers = filteredDrivers?.slice(startIndex, endIndex);

  const totalPages = Math.ceil(filteredDrivers?.length / rowsPerPage);

  const [expandedRow, setExpandedRow] = React.useState(null);

  const handleRowClick = (rowData, index) => {
    setLoading(true);
    setExpandedRow(expandedRow === index ? null : index);
    ViewRow(rowData);
  };

  useEffect(() => {
    if (data) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [data]);

  const ModelOpen = (img) => {
    setIsModalOpen(true);
    setImg(img);
  };

  return (
    <>
      <div className="mx-auto p-2 bg-white shadow-xl font-Poppins rounded-xl mx-5">
        <div className="flex items-center justify-between px-4 py-4 ">
          <h1 className="text-2xl font-semibold ">{TableTitle}</h1>

          {/* Search Bar */}

          <div className="flex items-center w-1/3 gap-2 ">
            <select
              value={profileStatusFilter}
              onChange={(e) => setProfileStatusFilter(e.target.value)}
              className="border border-gray-300 rounded-lg px-6 py-2 text-md font-medium focus:outline-none focus:ring focus:border-blue-300"
            >
              <option value="" className="font-medium">
                All Profiles
              </option>
              <option value="Approved" className="font-medium">
                Approved
              </option>
              <option value="Rejected" className="font-medium">
                Rejected
              </option>
              <option value="Unapproved" className="font-medium">
                Unapproved
              </option>
            </select>

            <div className="relative w-full w-1/2">
              <input
                type="text"
                placeholder="Search..."
                className="border border-gray-300 rounded-lg px-4 py-2 pr-10 w-full focus:outline-none focus:ring focus:border-blue-300"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  type="button"
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                  onClick={() => setSearchTerm("")}
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
            {currentDrivers ? (
              <>
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-3 py-3 text-left text-sm font-medium text-gray-600">
                      S No.
                    </th>
                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                      Image
                    </th>
                    {role === "Driver" ? (
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        <div>
                          Name & Mobile <br />
                          <span>Email Address</span>
                        </div>
                      </th>
                    ) : (
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Name & Mobile
                      </th>
                    )}
                    {(role === "Customer" ||
                      role === "Manager" ||
                      role === "Admin") && (
                      <>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Email Address
                        </th>
                        {role === "Customer" && (
                          <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                            Account Verified
                          </th>
                        )}
                      </>
                    )}

                    {role === "Driver" && (
                      <>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Total Rides
                        </th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Cancel Rides
                        </th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Total Amount
                        </th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Experience
                        </th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Profile Complete
                        </th>
                      </>
                    )}

                    {(role === "Admin" ||
                      role === "Driver" ||
                      role === "Manager") && (
                      <>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Account Status
                        </th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Profile Status
                        </th>
                      </>
                    )}
                    {/* <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                  Created At
                </th> */}
                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm divide-y divide-gray-200">
                  {currentDrivers?.map((driver, index) => (
                    <>
                      <tr key={driver?.id}>
                        <div className="pl-5 pt-8">
                          {" "}
                          {startIndex + index + 1}
                        </div>
                        <td className="px-6 py-4">
                          <img
                            src={
                              driver?.image || "https://via.placeholder.com/40"
                            }
                            alt="Driver"
                            className="h-10 w-10 rounded-full object-cover"
                          />
                        </td>

                        {role === "Driver" ? (
                          <td className="px-6 py-4">
                            <div className="font-medium">{driver?.name}</div>
                            <div className="text-gray-500">
                              {driver?.mobile_number}
                            </div>
                            <div className="text-gray-500">
                              {driver?.email_address}
                            </div>
                          </td>
                        ) : (
                          <>
                            <td className="px-6 py-4">
                              <div className="font-medium">{driver?.name}</div>
                              <div className="text-gray-500">
                                {driver?.mobile_number}
                              </div>
                            </td>
                          </>
                        )}
                        {(role === "Customer" ||
                          role === "Manager" ||
                          role === "Admin") && (
                          <>
                            <td className="px-6 py-4">
                              {driver?.email_address || driver?.email || "--"}
                            </td>
                            {role === "Customer" && (
                              <td className="px-6 py-4">
                                <span
                                  className={`px-2 py-1 ml-6 text-xs font-semibold cursor-pointer rounded-lg ${
                                    driver?.is_verified === true
                                      ? "text-green-600 bg-green-100"
                                      : "text-red-600 bg-red-100"
                                  }`}
                                >
                                  {driver?.is_verified === true
                                    ? "True"
                                    : "False"}
                                </span>
                              </td>
                            )}
                          </>
                        )}
                        {role === "Driver" && (
                          <>
                            <td className="px-6 py-4">
                              {driver?.total_rides || "--"}
                            </td>
                            <td className="px-6 py-4">
                              {driver?.cancel_rides || "--"}
                            </td>
                            <td className="px-6 py-4 ">
                              {driver.total_amount || "--"}
                            </td>
                            <td className="px-6 py-4 ">{driver?.experience}</td>
                            <td className="px-6 py-4">
                              {driver?.is_complete === true ? "True" : "False"}
                            </td>
                          </>
                        )}

                        {(role === "Admin" ||
                          role === "Driver" ||
                          role === "Manager") && (
                          <>
                            <td className="px-6 py-4">
                              <span
                                onClick={() =>
                                  handleAccountStatusChange(driver)
                                }
                                className={`px-2 py-1 text-xs font-semibold cursor-pointer rounded-lg ${
                                  driver?.account_status === 1
                                    ? "text-green-600 bg-green-100"
                                    : "text-red-600 bg-red-100"
                                }`}
                              >
                                {driver?.account_status === 1
                                  ? "Active"
                                  : "In-Active"}
                              </span>
                            </td>
                            <td className="px-6 py-4">
                              <span
                                onClick={() =>
                                  handleProfileStatusChange(driver)
                                }
                                className={`px-2 py-1 text-xs cursor-pointer font-semibold rounded-lg ${
                                  driver?.profile_status === 1
                                    ? "text-green-600 bg-green-100"
                                    : "text-red-600 bg-red-100"
                                }`}
                              >
                                {driver?.profile_status === 1
                                  ? "Approved"
                                  : driver?.profile_status === 2
                                  ? "Rejected"
                                  : "Unapproved"}
                              </span>
                            </td>
                          </>
                        )}

                        {/* <td className="px-6 py-4">
                        {new Date(driver?.created_at).toLocaleDateString("en-GB")}
                      </td> */}
                        <td className="px-2 py-4">
                          <>
                            {role === "Driver" && (
                              <>
                                {expandedRow === index ? (
                                  <>
                                    <button className="text-green-600 hover:text-green-800 mx-1">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        className="size-6 cursor-pointer mr-2"
                                        onClick={() => setExpandedRow(null)}
                                      >
                                        <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" />
                                        <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" />
                                        <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" />
                                      </svg>
                                    </button>
                                  </>
                                ) : (
                                  <button className="text-green-600 hover:text-green-800 mx-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="currentColor"
                                      className="size-6 cursor-pointer mr-2"
                                      // onClick={() => ViewRow(driver)}
                                      onClick={() =>
                                        handleRowClick(driver, index)
                                      }
                                    >
                                      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </button>
                                )}
                              </>
                            )}
                          </>

                          <button className="text-red-600 hover:text-red-800 mx-1 ml-5">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              className="size-6 cursor-pointer"
                              onClick={() => DeleteRow(driver)}
                              // onClick={() => handleRowClick(driver, index)}
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                      {expandedRow === index && (
                        <tr>
                          <td colSpan="12" className="p-0">
                            <div
                            // className={`overflow-hidden transition-all duration-300 ease-in-out ${
                            //   expandedRow === index ? "max-h-[500px]" : "max-h-0"
                            // }`}
                            >
                              {loading ? (
                                <>
                                  <div className="flex items-center justify-center py-5">
                                    <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div
                                    className="bg-gray-50 py-8 px-2 w-full"
                                    // style={{
                                    //   //   maxHeight: "80vh",
                                    //   overflowY: "auto",
                                    // }}
                                  >
                                    {/* Header Section */}
                                    <div className="max-w-8xl mx-10 mx-auto bg-gradient-to-r from-yellow-500 to-yellow-300 text-white shadow-xl rounded-xl p-8 relative">
                                      <div className="flex items-center space-x-8">
                                        <img
                                          src={data?.image}
                                          alt={data?.driver_name}
                                          className="w-40 h-40 rounded-full border-2 border-black shadow-lg"
                                        />
                                        <div>
                                          <h2 className="text-4xl font-extrabold font-Poppins tracking-tight text-black">
                                            {data?.driver_name}
                                          </h2>
                                          <p className="text-lg mt-2 text-black font-medium font-Poppins">
                                            Driver ID: {data?.id}
                                          </p>
                                          <p className="text-lg mt-2 text-black font-Poppins font-medium">
                                            Email Address: {data?.email_address}
                                          </p>
                                          <p className="text-lg mt-1 text-black font-Poppins font-medium">
                                            Mobile: {data?.mobile_number}
                                          </p>
                                          <p className="text-lg mt-1 text-black font-Poppins font-medium">
                                            Rating:{" "}
                                            <span className="text-green-500">
                                              ⭐
                                            </span>{" "}
                                            {data?.rating}
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Driver Details */}
                                    <DetailsSection title="Driver Details">
                                      <DetailRow
                                        label="Date of Birth"
                                        value={formatDate(data?.dob)}
                                      />
                                      {/* <DetailRow label="Father's Name" value={data?.fathername} /> */}
                                      {/* <DetailRow label="Father's Number" value={data?.fathernumber} /> */}
                                      <DetailRow
                                        label="Emergency Contact"
                                        value={data?.emergency_number}
                                      />
                                      <DetailRow
                                        label="Blood Group"
                                        value={data?.blood_group}
                                      />
                                      <DetailRow
                                        label="Experience"
                                        value={`${data?.experience} years`}
                                      />
                                      <DetailRow
                                        label="Height"
                                        value={`${data?.height} cm`}
                                      />
                                      <DetailRow
                                        label="Weight"
                                        value={`${data?.weight} kg`}
                                      />
                                    </DetailsSection>

                                    {/* Account and Ride Details */}
                                    <DetailsSection title="Bank Account and Ride Details">
                                      <DetailRow
                                        label="Account Holder"
                                        value={data?.account_holder || "--"}
                                      />
                                      <DetailRow
                                        label="Bank Name"
                                        value={data?.bank_name || "--"}
                                      />
                                      <DetailRow
                                        label="Account Number"
                                        value={data?.account_number || "--"}
                                      />
                                      <DetailRow
                                        label="Bank IFSC Code"
                                        value={data?.ifsc_code || "--"}
                                      />
                                      <DetailRow
                                        label="Aadhaar Number"
                                        value={data?.aadhaar_number || "--"}
                                      />
                                      <DetailRow
                                        label="Total Rides"
                                        value={data?.total_rides || "--"}
                                      />
                                      <DetailRow
                                        label="Cancelled Rides"
                                        value={data?.cancel_rides || "--"}
                                      />
                                      <DetailRow
                                        label="Total Earnings"
                                        value={`₹${data?.total_amount || "--"}`}
                                      />

                                      <div className="mt-4 flex flex-row">
                                        {data?.aadhar_img && (
                                          <>
                                            {data?.aadhar_img?.map(
                                              (item, index) => (
                                                <div key={`aadhar-${index}`}>
                                                  <div className="text-lg mx-2 font-semibold text-gray-700">
                                                    {index === 0
                                                      ? "Aadhaar Front:"
                                                      : "Aadhaar Back:"}
                                                  </div>
                                                  <div className="mt-2 ">
                                                    <img
                                                      src={item}
                                                      alt={`Aadhaar ${
                                                        index === 0
                                                          ? "Front"
                                                          : "Back"
                                                      }`}
                                                      className="w-52 h-96 mx-2 object-cover rounded-lg"
                                                      onClick={() =>
                                                        ModelOpen(item)
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </DetailsSection>

                                    {/* Vehicle Details */}
                                    <DetailsSection title="Vehicle Details">
                                      <DetailRow
                                        label="Car Name"
                                        value={data?.car_name || "--"}
                                      />
                                      <DetailRow
                                        label="Car Type"
                                        value={data?.car_type || "--"}
                                      />
                                      <DetailRow
                                        label="Car Number"
                                        value={data?.car_number || "--"}
                                      />

                                      <DetailRow
                                        label="Insurance Expiry"
                                        value={formatDate(
                                          data?.insuranceexpiry || "--"
                                        )}
                                      />
                                      {/* <DetailRow label="Car Images"></DetailRow> */}
                                    </DetailsSection>

                                    {/* Driver Docuemnt */}
                                    <div className="max-w-8xl mx-10 mx-auto mt-3 bg-white shadow-xl font-Poppins rounded-xl p-8">
                                      <h3 className="text-2xl font-bold text-gray-800 border-b pb-3">
                                        Driver Car Documents
                                      </h3>
                                      <div className="gap-6 mt-6 flex ">
                                        {/* Licence */}
                                        <div className="mt-4 flex flex-row">
                                          {data?.licence_originalname && (
                                            <>
                                              {data?.licence_originalname?.map(
                                                (item, index) => (
                                                  <div key={`licence-${index}`}>
                                                    <div className="text-lg mx-2 font-semibold text-gray-700">
                                                      {index === 0
                                                        ? "Licence Front:"
                                                        : "Licence Back:"}
                                                    </div>
                                                    <div className="mt-2 ">
                                                      <img
                                                        src={item}
                                                        alt={`Licence ${
                                                          index === 0
                                                            ? "Front"
                                                            : "Back"
                                                        }`}
                                                        className="w-52 h-96 mx-2 object-cover rounded-lg"
                                                        onClick={() =>
                                                          ModelOpen(item)
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                            </>
                                          )}
                                        </div>

                                        <div className="mt-4">
                                          <div className="text-lg font-semibold text-gray-700">
                                            Car Insurance:
                                          </div>
                                          <div className="mt-2">
                                            <img
                                              src={
                                                data?.car_insurance_originalname
                                              }
                                              alt="Insurance"
                                              className="w-52 h-96 object-cover rounded-lg "
                                              onClick={() =>
                                                ModelOpen(
                                                  data?.car_insurance_originalname
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        {/* Registration Certificate */}
                                        <div className="mt-4">
                                          <div className="text-lg font-semibold text-gray-700">
                                            Registration Certificate :
                                          </div>
                                          <div className="mt-2">
                                            <img
                                              src={data?.rc_originalname}
                                              alt="Registration Certificate"
                                              className="w-52 h-96  object-cover rounded-lg"
                                              onClick={() =>
                                                ModelOpen(data?.rc_originalname)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <ImageSlider images={data?.car_images} />

                                    {/* Action Buttons */}
                                    <div className="max-w-8xl mx-10 mt-8 flex justify-end space-x-4">
                                      <RejectDriverModal
                                        rowData={data}
                                        handlerefresh={handlerefresh}
                                      />
                                      <button
                                        onClick={() => {
                                          handleApprove(data);
                                          setExpandedRow(null);
                                        }}
                                        className="px-10 py-3 flex flex-row gap-3 bg-green-500 text-white text-lg font-Poppins font-medium rounded-lg shadow hover:bg-green-400 transition duration-300"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          fill="currentColor"
                                          className="size-6"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                        Approve
                                      </button>
                                    </div>
                                  </div>

                                  <ImageModal
                                    image={img}
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                  />
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </>
            ) : (
              <>
                <div className="my-[10%] font-medium font-Poppins text-3xl flex items-center justify-center">
                  No {role} Found!
                </div>
              </>
            )}
          </table>
        </div>

        {/* Pagination */}
        {currentDrivers && (
          <div className="flex justify-between items-center mt-4">
            <span className="text-sm text-gray-600">
              Showing {startIndex + 1}-
              {Math.min(endIndex, filteredDrivers?.length)} of{" "}
              {filteredDrivers?.length}
            </span>
            <div className="flex">
              <button
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-200"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-200 ml-2"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function DetailsSection({ title, children }) {
  return (
    <div className="max-w-8xl mx-10 mx-auto mt-3 bg-white shadow-xl font-Poppins rounded-xl p-8">
      <h3 className="text-2xl font-bold text-gray-800 border-b pb-3">
        {title}
      </h3>
      <div className="grid grid-cols-2 gap-6 mt-6">{children}</div>
    </div>
  );
}

function DetailRow({ label, value, children }) {
  return (
    <div className="flex items-center px-2 py-2 bg-[#f1f1f1] rounded-sm">
      <div className="w-1/2 ">
        <p className="text-sm font-semibold font-Poppins text-gray-800">
          {label}:
        </p>
      </div>
      <div className="w-2/3 px-4">
        {value ? (
          <p className="text-gray-700 font-Poppins text-base">
            {value || "--"}
          </p>
        ) : (
          <div className="mt-2">{children}</div>
        )}
      </div>
    </div>
  );
}

function ImageSlider({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images?.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images?.length - 1 : prevIndex - 1
    );
  };

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") {
        handleNext();
      } else if (event.key === "ArrowLeft") {
        handlePrevious();
      } else if (event.key === "Escape") {
        closeModal();
      }
    };

    if (isModalOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isModalOpen]);

  return (
    <div className="max-w-8xl mx-10 mx-auto mt-3 bg-white shadow-xl rounded-xl p-5">
      <h3 className="text-2xl font-bold font-Poppins text-gray-800 border-b pb-3">
        Car Images
      </h3>

      <div className="flex flex-row flex-wrap py-2">
        {images?.map((item, index) => (
          <div key={index} className="w-56 h-64 m-2">
            <img
              src={item}
              alt={`Slide ${index + 1}`}
              className="w-full h-full object-cover rounded-md"
              onClick={() => openModal(index)}
            />
          </div>
        ))}
      </div>

      {/* Full-Screen Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          {/* Close Icon */}
          <button
            onClick={closeModal}
            className="absolute top-20 right-10 w-8 h-8  text-white text-3xl font-bold bg-black/50  rounded-full"
          >
            &times;
          </button>

          <div className="relative bg-[pink] ml-[15%] z-50">
            <img
              src={images[currentIndex]}
              alt={`Slide ${currentIndex + 1}`}
              className="max-w-[80vw] max-h-[90vh] object-contain rounded-lg z-50"
            />

            {/* Left Navigation */}
            <button
              onClick={handlePrevious}
              className="absolute top-1/2 left-5 transform -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 transition duration-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path
                  fillRule="evenodd"
                  d="M10.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L12.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                  clipRule="evenodd"
                />
                <path
                  fillRule="evenodd"
                  d="M4.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L6.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {/* Right Navigation */}
            <button
              onClick={handleNext}
              className="absolute top-1/2 right-5 transform -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 transition duration-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path
                  fillRule="evenodd"
                  d="M13.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L11.69 12 4.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
                  clipRule="evenodd"
                />
                <path
                  fillRule="evenodd"
                  d="M19.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06L17.69 12l-6.97-6.97a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function ImageModal({ image, isModalOpen, setIsModalOpen }) {
  const [zoomLevel, setZoomLevel] = useState(1);

  const handleZoom = (e) => {
    e.preventDefault(); // Prevent the page from scrolling
    const delta = e.deltaY > 0 ? -0.1 : 0.1; // Zoom out on scroll down, zoom in on scroll up
    setZoomLevel((prev) => Math.min(Math.max(prev + delta, 1), 5)); // Limit zoom between 1x and 5x
  };

  return (
    <>
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onWheel={handleZoom}
        >
          {/* Close Icon */}
          <button
            onClick={() => setIsModalOpen(false)}
            className="absolute top-20 right-10 w-8 h-8  text-white text-3xl font-bold bg-black/50  rounded-full"
          >
            &times;
          </button>

          <div className="relative ml-[15%] z-50">
            <img
              src={image}
              alt="Zoomable"
              className="max-w-[80vw] max-h-[80vh] object-contain rounded-lg"
              style={{
                transform: `scale(${zoomLevel})`,
                transition: "transform 0.1s ease",
              }}
            />
          </div>
          {/* Zoom Info */}
          <div className="absolute top-5 left-5 bg-gray-800 text-white p-2 rounded shadow">
            Zoom Level: {zoomLevel.toFixed(1)}x
          </div>
        </div>
      )}
    </>
  );
}

function formatDate(date) {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
